<template>
	<div class="nav-menu">
		<!-- :collapse="isCollapse" -->
		<el-menu
			class="el-menu-vertical-demo"
			active-text-color="#303133"
			@open="handleOpen"
			@close="handleClose"
			:router="true"
			ref="elmenu"
		>
			<div v-for="(route, index) in sideBar" :key="route.id">
				<el-submenu :index="'' + (index + 1)" v-if="route.tabbar == 'child'">
					<template slot="title" :data-item="route">
						<img class="icon-img" :src="route.imgActive" v-if="routerActive == index + 1" alt="" />
						<img class="icon-img" :src="route.img" v-else alt="" />
						<span
							class="sub-menu-name"
							:class="{
								activecolor: routerActive == index + 1,
								red: route.read_status > 0,
							}"
							>{{ route.name }}</span
						>
					</template>
					<!-- 一级导航头 （含子级） end -->
					<el-menu-item-group>
						<el-menu-item
							v-for="child in route.children"
							:index="child.route.path"
							:key="child.id"
							:data-item="route"
							:route="route.route"
							class="sub-menu-name"
							:class="{
								activecolor: currentRoute.meta.title == child.name,
								redsub: route.read_status > 0,
							}"
							@click="onClickRouter(child, index)"
						>
							{{ child.name }}</el-menu-item
						>
					</el-menu-item-group>
					<!-- 二级导航头 end -->
				</el-submenu>
				<el-menu-item
					:class="{ activecolor: currentRoute.meta.title == route.name }"
					:index="route.route.path"
					v-else-if="route.tabbar == 'main'"
					:data-item="route"
					:route="route.route"
					@click="onClickRouter(route, index)"
				>
					<img
						class="icon-img"
						:src="route.imgActive"
						v-if="currentRoute.meta.title == route.name"
						alt=""
					/>
					<img class="icon-img" :src="route.img" v-else alt="" />
					<div
						class="title_name"
						style="display: inline-block"
						slot="title"
						:class="{ activecolor: currentRoute.meta.title == route.name }"
					>
						{{ route.name }}
						<spanv class="news_state" v-if="newsState(route)"></spanv>
					</div>
				</el-menu-item>
				<!-- 一级导航头 end -->
			</div>
		</el-menu>
	</div>
</template>

<script>
	let routeMenuTimer = null;
	import { routes } from '../router';
	export default {
		props: {
			list: {
				type: Array,
				required: true,
			},
		},
		computed: {
			activeMenu() {
				const route = this.$route;
				const { path } = route;
				// if set path, the sidebar will highlight the path you set
				return path;
			},
		},
		watch: {
			$route: {
				handler: function (val, oldVal) {
					this.currentRoute = val;
					this.$forceUpdate();
				},
				// 深度观察监听
				deep: true,
			},
			list: {
				deep: true, // 深度监听
				handler(newVal, oldVal) {
					this.$data.propsSidBar = newVal;
				},
			},
		},
		data() {
			return {
				isCollapse: false,
				propsSidBar: [],
				// 左侧 导航栏
				sideBar: [],
				routerActive: '1',
				currentRoute: {},

				// 消息判断
				newsState: (route) => {
					return route.name == '消息通知' && route.read_status == 1;
				},
			};
		},
		beforeCreate() {},
		created() {
			this.currentRoute = this.$route;
			this.getSideBar();
		},
		beforeMount() {},
		mounted() {
			window.onresize = () => {
				return (() => {
					window.screenWidth = document.body.clientWidth;
					if (window.screenWidth < 1260) {
						this.isCollapse = true;
					}
					if (window.screenWidth >= 1280) {
						this.isCollapse = false;
					}
				})();
			};
		},
		beforeUpdate() {},
		updated() {},
		beforeDestroy() {},
		destroyed() {},
		methods: {
			handleOpen(key, keyPath) {
				// console.log(key, keyPath);
				// this.routerActive = key;
			},
			handleClose(key, keyPath) {
				// console.log(key, keyPath);
			},
			// 点击 左侧 导航栏
			onClickRouter(ev, index) {
				if (ev.read_status > 0) {
					if (routeMenuTimer) {
						clearTimeout(routeMenuTimer);
					}
					routeMenuTimer = setTimeout(() => {
						this.$emit('getSideBar');
					}, 1200);
				}
				this.routerActive = index + 1;
			},
			/**
			 * 获取 左侧导航栏数据
			 */
			getSideBar() {
				this.sideBar = this.list.map((item, index) => {
					if (this.currentRoute.meta.title == item.name) {
						this.routerActive = `${index + 1}`;
					}

					if (
						(item.children.length > 0 && item.children[0].level == 3) ||
						(item.level == 1 && item.children.length == 0)
					) {
						item.tabbar = 'main';
					} else if (item.children[0].level == 2) {
						item.children.forEach((key) => {
							key.route = routes.find(function checkRoute(val) {
								return val.children && val.children[0].meta.title == key.name;
							});
							if (this.currentRoute.meta.title == key.name) {
								this.routerActive = `${index + 1}`;
							}
						});

						item.tabbar = 'child';
					} else {
						item.tabbar = 'content';
					}
					item.route = routes.find(function checkRoute(val) {
						return val.children && val.children[0].meta.title == item.name;
					});
					item.img = require('../assets/icon/' + item.icon);
					item.imgActive = require('../assets/icon/' + item.activity_icon);
					return item;
				});
				console.log(this.sideBar);
				// console.log('左侧导航栏数据', this.sideBar);

				setTimeout(() => {
					try {
						this.$refs.elmenu.open(this.routerActive);
					} catch (error) {}
				}, 2000);
			},
		},
	};
</script>

<style lang="scss" scoped>
	.nav-menu {
		padding-left: 0px;
		.el-menu-vertical-demo:not(.el-menu--collapse) {
			// width: 240px;
			// min-height: 100vh;
		}
	}
	.a {
		display: inline-block;
	}
	.icon-shelf {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.icon-img {
		margin-right: 8px;
		max-width: 14px;
		max-height: 14px;
	}
	.news_state {
		display: inline-block;
		width: 6px;
		height: 6px;
		margin-top: -3px;
		margin-left: 3px;
		background: rgba(230, 50, 65, 1);
		border-radius: 50%;
	}
	.activecolor {
		color: #e60000;
	}
	.sub-menu-name.redsub::after {
		content: '';
		position: absolute;
		top: 10px;
		left: 30px;
		width: 6px;
		height: 6px;
		background-color: #e60000;
		border-radius: 50%;
	}
	.sub-menu-name.red::after {
		content: '';
		position: absolute;
		top: -4px;
		right: -2px;
		width: 6px;
		height: 6px;
		background-color: #e60000;
		border-radius: 50%;
	}
	.sub-menu-name {
		position: relative;
		padding-right: 10px;
	}
	.el-menu-item.activecolor {
		position: relative;
		background: rgba(230, 50, 65, 0.1);
	}
	::v-deep .el-menu-item.activecolor::after {
		content: '';
		position: absolute;
		top: 0px;
		right: -1px;
		width: 2px;
		height: 100%;
		background-color: #e60000;
	}
	::v-deep .el-submenu__title:hover,
	::v-deep .el-menu-item:hover {
		background: rgba(230, 50, 65, 0.1);
	}
</style>
